import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import CheckboxBase from '@material-ui/core/Checkbox';
import clsx from 'clsx';
import checkmarkIcon from './checkmark-thick.svg';
import { StyledText } from './StyledText';
import { theme } from '../styles/theme';

const useStyles = makeStyles(() => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: 0,
    height: 'auto'
  },
  content: {
    '&:hover': {
      backgroundColor: 'transparent'
    },
    padding: '4.5px 9px 4.5px 0px'
  },
  icon: {
    borderRadius: 3,
    width: 20,
    height: 20,
    margin: 0,
    boxShadow: 'none',
    border: `2px ${theme.palette.secondary.dark} solid`,
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2
    },
    'input:hover ~ &': {
      backgroundColor: 'rgba(206,217,224,.5)'
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)'
    }
  },
  checkedIcon: {
    backgroundColor: theme.palette.secondary.main,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '17px 17px',
    backgroundImage: `url(${checkmarkIcon})`,
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      content: '""'
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.secondary.dark
    }
  }
}));


type CheckboxArgs = {
  id: string,
  checked: boolean,
  label: string,
  onChange: any,
  onBlur: any,
};

const Checkbox: React.FC<CheckboxArgs> = (
  {
    id,
    label,
    checked = false,
    onChange,
    onBlur
  }: CheckboxArgs
) => {
  const styles = useStyles();
  return (
    <Box className={styles.row}>
      <CheckboxBase
        className={styles.content}
        disableRipple
        color='default'
        id={id}
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
        checkedIcon={<span className={clsx(styles.icon, styles.checkedIcon)} />}
        icon={<span className={styles.icon} />}
      />
      <StyledText component='label' htmlFor={id}>
        {label}
      </StyledText>
    </Box>
  );
};

Checkbox.defaultProps = {

};

export default Checkbox;

